import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ToastResponse } from '../../utilities/ToastResponse';
import { SettingUpdate } from '../../services';

export const fetchSettingUpdate = createAsyncThunk(
    'settingUpdate/fetchSettingUpdate',
    async ({ siteName, file, banner, background, background2, background3, background4 }) => {
        const response = await SettingUpdate(siteName, file, banner, background, background2, background3, background4);
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
);

const settingUpdateSlice = createSlice({
    name: 'settingUpdate',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSettingUpdate.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchSettingUpdate.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchSettingUpdate.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default settingUpdateSlice.reducer;
